'use client';
import { useEffect, useState } from 'react';
import { IoClose } from 'react-icons/io5';

import { SIZE_ENUM } from '@/components/@base/@helpers/types';
import Button from '@/components/@base/button';
import Container from '@/components/@base/container';
import { Text } from '@/components/@base/typography';
import ClearFiltersButton from '@/components/app/archive/components/filter/@shared/clear-filters-button';
import FilterItems from '@/components/app/archive/components/filter/@shared/items';
import ShowFilterButton from '@/components/app/archive/components/filter/mobile/show-filter-button';
import Props from '@/components/app/archive/components/filter/mobile/type';

import useCommonModalStore from '@/store/common-modal-store';

import { DATA_CY_FILTER_IN_MOBILE } from '@/constant/cypress';
import ICON_SIZE from '@/constant/icon-size-color';
import { pageLevelLocalization } from '@/constant/localization';

const { archive: archiveLocalization } = pageLevelLocalization;

export default function Filter({ initialFilters }: Props) {
  const [showFilter, setShowFilter] = useState(false);
  const { setShow } = useCommonModalStore();

  useEffect(() => {
    setShow(showFilter, {
      DialogPanelProps: {
        className: 'rounded-md overflow-visible p-0 mx-4 my-14 sm:mx-11 sm:min-w-[340px]',
      },
      DialogProps: { onClose: () => setShowFilter(false) },
      Head() {
        return (
          <Container
            center
            className='justify-between border-b-[1px] border-[#F4F5F6] px-6 py-5'
          >
            <Text size={SIZE_ENUM.LG} bold className='text-[#424244]'>
              {archiveLocalization.showFilter}
            </Text>
            <Button
              className='h-[33px] w-[33px] bg-[#F7F8F9] text-[#424244]'
              onClick={() => setShowFilter(false)}
            >
              <IoClose color='#878F9B' size={ICON_SIZE.md} />
            </Button>
          </Container>
        );
      },
      Body() {
        return (
          <>
            <Container className='p-6'>
              <FilterItems initialFilters={initialFilters} />
            </Container>
            <Container className='relative'>
              <Container center className='absolute top-4 right-0 left-0 flex-col'>
                <Button
                  onClick={() => setShowFilter(false)}
                  className='h-[60px] w-full text-[15px] font-bold'
                >
                  {archiveLocalization.filter.applyFilters}
                </Button>
                <ClearFiltersButton
                  initialFilters={initialFilters}
                  className='text-xs font-bold text-[#F4F5F6]'
                />
              </Container>
            </Container>
          </>
        );
      },
    });
  }, [showFilter]);

  return (
    <Container
      data-cy={DATA_CY_FILTER_IN_MOBILE}
      center
      className='px-4 md:hidden md:max-w-[1200px]'
    >
      <ShowFilterButton onShowFilterClick={() => setShowFilter(true)} />
    </Container>
  );
}
